import Typography from '@mui/material/Typography';
import { Button, IconButton, TextField, InputAdornment } from '@mui/material';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import { useNavigationCore } from '../../../../core/router/navigation';
import PrintIcon from '@mui/icons-material/Print';
import SearchIcon from '@mui/icons-material/Search';
import { useCallback } from 'react';

interface HeaderProps {
  onSearch: (term: string) => void;
  onClearSearch: () => void;
  searchTerm: string;
  total: number;
  onPrintAll: () => void;
  printDisabled?: boolean;
}

const Header: React.FC<HeaderProps> = ({
  onSearch,
  onClearSearch,
  searchTerm,
  total,
  onPrintAll,
  printDisabled = false,
}) => {
  const { goToReceptions } = useNavigationCore();

  const handleSearch = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;
      onSearch(value);
    },
    [onSearch]
  );

  const handleClearSearch = useCallback(() => {
    onClearSearch();
  }, [onClearSearch]);

  return (
    <div className="p-24 sm:p-32 w-full border-b-1 bg-white header-components">
      <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
        <div className="flex flex-col items-center sm:items-start">
          <div className="flex items-center">
            <IconButton color="secondary" onClick={goToReceptions}>
              <ArrowBackOutlinedIcon className="mr-6" />
            </IconButton>
            <Typography className="text-24 md:text-32 font-extrabold tracking-tight leading-none">
              Contenedores de origen
            </Typography>
          </div>
          <Typography className="text-14 font-medium" color="text.secondary">
            {total} contenedor/es
          </Typography>
        </div>

        <div className="flex flex-col sm:flex-row items-center gap-4">
          <TextField
            size="small"
            placeholder="Buscar por código..."
            value={searchTerm}
            onChange={handleSearch}
            variant="outlined"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="action" />
                </InputAdornment>
              ),
            }}
            sx={{
              minWidth: 250,
              backgroundColor: 'white',
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: '#e0e0e0',
                },
                '&:hover fieldset': {
                  borderColor: '#1976d2',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#1976d2',
                },
              },
            }}
          />

          <Button className="mx-4 my-4 w-100" color="secondary" onClick={onPrintAll} disabled={printDisabled}>
            <PrintIcon className="mx-2" />
            Imprimir todo
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Header;
